import React from "react";
import "../HomePage.css";

const HomePage = () => {
    return (
        <div className="home">
        <h1> Welcome</h1>
        <h2>to Dump It India</h2>
        </div>
    );
};

export default HomePage;
